<template>
  <b-modal ref="audioModal" v-model="showModal" title="Gravar Áudio">
    <div class="audio-recorder text-center mt-3">
      <button @click="toggleRecording" :class="['btn', 'btn-lg', isRecording ? 'btn-danger' : 'btn-primary']">
        <i :class="['fas', isRecording ? 'fa-stop-circle' : 'fa-microphone']"></i>
        {{ isRecording ? 'Parar Gravação' : 'Iniciar Gravação' }}
      </button>

      <div v-if="isRecording" class="recording-indicator mt-2">
        <span class="dot"></span> Gravando...
      </div>
      <audio v-if="audioUrl" :src="audioUrl" controls class="mt-3 w-100"></audio>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-success btn-sm" @click="sendAudio" v-b-tooltip.hover title="Enviar" :disabled="!audioUrl">
          <i class="fas fa-check-circle"></i><span class="d-md-down-none">Enviar</span>
        </button>
    </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'AudioModal',
  data () {
    return {
      showModal: false,
      isRecording: false,
      audioUrl: null,
      mediaRecorder: null,
      audioChunks: [],
      audioBase64: null,
      file: null
    }
  },
  props: {
    reply: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    show () {
      this.showModal = true
    },
    async toggleRecording () {
      if (this.isRecording) {
        this.mediaRecorder.stop()
        this.isRecording = false
      } else {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' })
        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data)
        }
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' })
          this.audioUrl = URL.createObjectURL(audioBlob)
          this.audioBase64 = await this.convertBlobToBase64(audioBlob)
          this.file = new File([audioBlob], 'audio.webm', { type: 'audio/webm' })
          this.audioChunks = []
        }
        this.mediaRecorder.start()
        this.isRecording = true
      }
    },
    async convertBlobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    sendAudio () {
      const fileInfo = {
        fileName: this.file.name,
        mimeType: this.file.type,
        type: 'ptt',
        fileBase: this.audioBase64.split('base64,')[1],
        quotedMsg: this.getQuotedMsg()
      }
      console.log(fileInfo)
      this.$emit('sendAudio', fileInfo)
      this.showModal = false
    },
    getQuotedMsg () {
      if (this.reply && this.reply.message) {
        return this.reply.message.messageId
      }
      return null
    }
  }
}
</script>
<style scoped>
.recording-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: red;
}
.recording-indicator .dot {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-right: 8px;
  animation: blink 1s infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/modal/AudioModal.vue